import './../Status.scss';
import React from 'react';
import { useEffect, useRef, useState } from 'react'
import { useAppSelector } from '../../../../redux/hooks';
import { useDispatch } from 'react-redux';
import Plot from "react-plotly.js";
import { DataName, SensorNodeStatus } from '../../../../util/model';

interface Props {
    index: number;
}

export default function SNR(props: Props) {
    const colorGray = 'rgba(140,140,140,1)';
    const colorWhite = 'rgba(255,255,255,1)';
    const colorYellow = 'rgba(255,255,140,1)';
    const colorRed = 'rgba(255,140,140,1)';
    let layout_locktime_init = {
        height: 300,
        title: {
            text: 'Lock Time',
            font: {
                color: 'white',
                size: 12
            }
        },
        margin: {
            l: 100,
            r: 30,
            b: 100,
            t: 30,
            pad: 0
        },
        showlegend: false,
        legend: {
            font: {color: 'white'}
        },
        xaxis: {
            title: {
                text: '',
                font: {
                    color: 'white'
                }
            },
            autorange: true,
            tickcolor: 'white',
            tickfont: {
                color: 'white'
            },
            gridcolor: 'rgb(110, 110, 50)',
            mirror: true,
            linewidth: 1,
            linecolor: 'rgb(255, 255, 140)'
        },
        yaxis : {
            title: {       
                font: {
                    color: 'white'
                }
            },        
            autorange: true,
            tickcolor: 'white',
            tickfont: {
                color: 'white'
            },
            gridcolor: "rgb(110, 110, 50)",
            mirror: true,
            linewidth: 1,
            linecolor: "rgb(255, 255, 140)"
        },
        plot_bgcolor :'black',
        paper_bgcolor:'black'
    };
    const [layout_locktime, setLockTimeLayout] = useState(layout_locktime_init);
    let locktime_init = {
        x: ['CH0 ()','CH1 ()','CH2 ()','CH3 ()','CH4 ()','CH5 ()','CH6 ()','CH7 ()','CH8 ()','CH9 ()',
            'CH10 ()','CH11 ()','CH12 ()','CH13 ()','CH14 ()','CH15 ()','CH16 ()','CH17 ()','CH18 ()','CH19 ()',
            'CH20 ()','CH21 ()','CH22 ()','CH23 ()','CH24 ()','CH25 ()','CH26 ()','CH27 ()','CH28 ()','CH29 ()'],
        y: [0,0,0,0,0,0,0,0,0,0,
            0,0,0,0,0,0,0,0,0,0,
            0,0,0,0,0,0,0,0,0,0],
        type: 'bar',
        name: 'Lock Time',
        marker: {color: ['rgb(0, 0, 0)']}
    };
    const [data_locktime, setLockTimeData] = useState([locktime_init]);

    const dispatch = useDispatch();
    const layerData = useAppSelector(state => state.layerData);
    
    const SNTime = layerData.status.Time;
    const SNStatus = layerData.status.SensorNodeStatus;
    
    useEffect(() => {
        if((props.index >= 0) && (props.index < SNStatus.length)) {
            var localTime = new Date(SNStatus[props.index].Tracking.Time);
            let sColor: Array<string> = [];
            for(let i = 0; i < SNStatus[props.index].Tracking.PRN.length; ++i) {
                if(SNStatus[props.index].Tracking.FPGA[i] === 'LOCKED') {
                    if(SNStatus[props.index].Tracking.Source[i] === 'UNKNOWN') {
                        sColor.push(colorGray);
                    } else if(SNStatus[props.index].Tracking.Source[i] === 'SPOOFER') {
                        sColor.push(colorRed);
                    } else {
                        if(SNStatus[props.index].Tracking.Band[i] === 'L1') {
                            sColor.push(colorWhite);
                        } else {
                            sColor.push(colorYellow);
                        }
                    }
                } else {
                    sColor.push(colorGray);
                }
            }
            let X: Array<string> = [];
            for(let i = 0; i < SNStatus[props.index].Tracking.PRN.length; ++i) {
                if(SNStatus[props.index].Tracking.PRN[i] < 0) {
                    X.push('CH' + i.toString() + ' ()');
                } else {
                    X.push('CH' + i.toString() + ' (' + SNStatus[props.index].Tracking.PRN[i].toString() + ')');
                }
            }
            let LockTime: Array<number> = [];
            for(let i = 0; i < SNStatus[props.index].Tracking.PRN.length; ++i) {
                if(SNStatus[props.index].Tracking.LockTime[i] < 0) {
                    LockTime.push(0/0);
                } else {
                    LockTime.push(SNStatus[props.index].Tracking.LockTime[i]);
                }
            }
            setLockTimeData([{
                x: X,
                y: LockTime,
                type: 'bar',
                name: 'Lock Time',
                marker: {color: sColor}
            }]);
            let locktimeLayout = layout_locktime;
            locktimeLayout.title.text = SNStatus[props.index].Name + ' Lock Time ' + localTime.toLocaleString();
            setLockTimeLayout(locktimeLayout);
        } else {
            var locktime = {
                x: ['CH0 ()','CH1 ()','CH2 ()','CH3 ()','CH4 ()','CH5 ()','CH6 ()','CH7 ()','CH8 ()','CH9 ()',
                    'CH10 ()','CH11 ()','CH12 ()','CH13 ()','CH14 ()','CH15 ()','CH16 ()','CH17 ()','CH18 ()','CH19 ()',
                    'CH20 ()','CH21 ()','CH22 ()','CH23 ()','CH24 ()','CH25 ()','CH26 ()','CH27 ()','CH28 ()','CH29 ()'],
                y: [0,0,0,0,0,0,0,0,0,0,
                    0,0,0,0,0,0,0,0,0,0,
                    0,0,0,0,0,0,0,0,0,0],
                type: 'bar',
                name: 'LockTime',
                marker: {color: ['rgb(0, 0, 0)']}
            };
            setLockTimeData([locktime]);  
            let locktimeLayout = layout_locktime;
            locktimeLayout.title.text = 'Lock Time';
            setLockTimeLayout(locktimeLayout);
        } 
    }, [SNTime, props.index]);
    
    return (
        <div>
	    <Plot data={data_locktime as any} layout={layout_locktime} useResizeHandler={true} className='status_plot' style={{ width: '100%', height: '100%' }}/>
        </div>
    )
}
